import React, { FC } from 'react'
import FbImageLibrary from '../../../FbImageLibrary'

import ExampleAvatar from '../../../../assets/img/example/story.svg'
import Comments from '../../../UI/Icons/Comments'

import Ellipsis from '../../../UI/Icons/Ellipsis'
import Like from '../../../UI/Icons/Like'
import AssesmentLike from '../../../UI/Icons/linkedin/AssesmentLike'
import AssesmentsClap from '../../../UI/Icons/linkedin/AssesmentsClap'
import AssesmentsHeart from '../../../UI/Icons/linkedin/AssesmentsHeart'
import SendIcon from '../../../UI/Icons/Send'
import Share from '../../../UI/Icons/Share'
import { SOCIAL_NETWORK } from '../../../../models/post'
import MessageFieldWithExtra from '../../PostEditor/UI/MessageField'
import LinkPreview from '../../PostEditor/UI/LinkPreview'

import { TPostSocialManagePost } from '../../../../store/managePost/newTypes'
import { TSocialDetails } from '../../../../selectors/ProjectSelector'

import './LinkedinPreview.scss'
import VideoPreview from '../../../UI/VideoPreview'
import LoadableImage from '../../../UI/LoadableImage'

interface LinkedinPreviewProps {
  isMokup?: boolean
  socialPost: TPostSocialManagePost
  isMobile?: boolean
  restrictions: any
  socialDetails: TSocialDetails
  publishDate: string
}

const LinkedinPreview: FC<LinkedinPreviewProps> = ({
  isMokup,
  socialPost,
  publishDate,
  isMobile = false,
  restrictions,
  socialDetails
}) => {
  return (
    <div
      className={`post-preview linkedin-preview ${isMokup && 'mokup'} ${isMobile && 'mobile-view'}`}
    >
      <div className='linkedin-content'>
        <div className='linkedin-content__customer'>
          <div className='linkedin-content__customer__avatar'>
            {socialDetails[SOCIAL_NETWORK.LINKEDIN_SOCIAL].logo.original ? (
              <LoadableImage media={socialDetails[SOCIAL_NETWORK.LINKEDIN_SOCIAL].logo.original!} />
            ) : (
              socialDetails[SOCIAL_NETWORK.LINKEDIN_SOCIAL]!.logo.default
            )}
          </div>
          <div className='linkedin-content__customer__data'>
            <div className='linkedin-content__customer__data__name'>
              {socialDetails[SOCIAL_NETWORK.LINKEDIN_SOCIAL]!.name}
            </div>
            <div className='linkedin-content__customer__data__followers'>15 000 folowers</div>
            <div className='linkedin-content__customer__data__last-seen'>
              {publishDate} &#xB7;
            </div>
          </div>
          <div className='linkedin-content__customer__etc'>
            <Ellipsis />
          </div>
        </div>
        {/* message */}
        <div className='linkedin-content__content'>
          <div className='linkedin-content__content__text'>
            {socialPost.message && (
              <MessageFieldWithExtra
                {...{
                  social: socialPost.social_network,
                  editorRaws: socialPost.message_editor_state,
                  value: socialPost.message
                }}
              />
            )}
          </div>
        </div>
        {restrictions.link && (
          <LinkPreview attachment={socialPost.attachments[0]} isEditable={false} />
        )}
      </div>
      {/* image */}
      {restrictions.mediaRestrictions.image && !!socialPost.attachments.length && (
        <div className='linkedin-images'>
          <FbImageLibrary
            hideOverlay={true}
            images={socialPost.attachments
              .filter(({ object_data }) => !!object_data)
              .map(({ object_data }) => object_data!)}
            isEditable={false}
          />
        </div>
      )}
      {/* video */}
      {restrictions.mediaRestrictions.video && !!socialPost.attachments.length && (
        <div className='linkedin-videos'>
          <VideoPreview
            attachment={socialPost.attachments[0]}
            width={isMokup ? 125 : 300}
            className='linkedin-videos__video'
          />
        </div>
      )}
      <div className='linkedin-assessments'>
        <div className='linkedin-assessments__item'>
          <AssesmentLike />
        </div>
        <div className='linkedin-assessments__item'>
          <AssesmentsClap />
        </div>
        <div className='linkedin-assessments__item'>
          <AssesmentsHeart />
        </div>
        <div className='linkedin-assessments__quantity'>3 000 &#xB7;</div>
        <div className='linkedin-assessments__commments'>78 comments</div>
      </div>
      <div className='linkedin-reactions'>
        <div className='linkedin-reactions__item'>
          <div className='linkedin-reactions__item__icon'>
            <Like />
          </div>
          <div className='linkedin-reactions__item__message'>Like</div>
        </div>
        <div className='linkedin-reactions__item'>
          <div className='linkedin-reactions__item__icon'>
            <Comments />
          </div>
          <div className='linkedin-reactions__item__message'>Comment</div>
        </div>
        <div className='linkedin-reactions__item'>
          <div className='linkedin-reactions__item__icon'>
            <Share />
          </div>
          <div className='linkedin-reactions__item__message'>Share</div>
        </div>
        <div className='linkedin-reactions__item'>
          <div className='linkedin-reactions__item__icon'>
            <SendIcon />
          </div>
          <div className='linkedin-reactions__item__message'>Send</div>
        </div>
      </div>
    </div>
  )
}

export default LinkedinPreview
